import styled from 'styled-components';
import QuestionSvg from '@src/assets/imgs/sponser/question_icon.svg';
import AnswerSvg from '@src/assets/imgs/sponser/answer_icon.svg';
import { sponserCardList } from '@src/data/sponser';
import { devices } from '@src/styles/theme';

const SevenCard = () => {
  return (
    <>
      {sponserCardList.map((item, i) => (
        <Container>
          <QuestionFlex>
            <div>
              <QuestionIcon />
            </div>
            <QuestionText>{item.question}</QuestionText>
          </QuestionFlex>
          <AnswerFlex>
            <div>
              <AnswerIcon />
            </div>
            <AnswerText>{item.answer}</AnswerText>
          </AnswerFlex>
        </Container>
      ))}
    </>
  );
};

const Container = styled.div`
  padding: 40px;
  background-color: ${({ theme }) => theme.commonColor.pink002};
  border-radius: 20px;
  width: 1010px;
  margin: 0 auto;
  &:nth-child(3) {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  @media ${devices.tablet} {
    width: fit-content;
    border-radius: 10px;
    padding: 18px;
    &:nth-child(2) {
      margin-top: 30px;
      margin-bottom: 30px;
    }
  }
`;

const QuestionText = styled.div`
  color: ${({ theme }) => theme.commonColor.pink004};
  font-family: 'NOTO';
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.9px;
  margin-left: 30px;

  @media ${devices.tablet} {
    font-size: 16px;
    line-height: 24px; /* 150% */
    margin-left: 13px;
  }
`;

const AnswerText = styled.div`
  color: ${({ theme }) => theme.commonColor.black};
  font-family: 'Var';
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px;
  margin-left: 30px;

  @media ${devices.tablet} {
    font-size: 12px;
    line-height: 20px; /* 166.667% */
    letter-spacing: -0.13px;
    margin-left: 13px;
  }
`;

const QuestionIcon = styled(QuestionSvg)`
  width: 80px;
  height: 80px;
  @media ${devices.tablet} {
    width: 30px;
    height: 30px;
  }
`;
const AnswerIcon = styled(AnswerSvg)`
  width: 80px;
  height: 80px;
  @media ${devices.tablet} {
    width: 30px;
    height: 30px;
  }
`;

const QuestionFlex = styled.div`
  display: flex;
  align-items: center;
`;

const AnswerFlex = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 30px;
  @media ${devices.tablet} {
    margin-top: 22px;
  }
`;

export default SevenCard;
